import React, { useState, useEffect, useMemo, useCallback } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import {
  Grid,
  Container,
  Box,
  Stack,
  ListItemText,
  IconButton,
  Menu,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tab,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDocsList } from "../../../../redux/docs/index.js";
import HeaderDocs from "./headerDocs/index.js";
import Avatar from "../../../../components/uiElements/avatar/index";
import moment from "moment";
import ResponseAlert from "../../../../components/responseAlert/index.js";
import { deleteFolder } from "../../../../redux/docs/addfolderapi.js";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { DataGridPro } from "@mui/x-data-grid-pro";
import AddFolder from "./addFolder/index.jsx";
import TableSkeleton from "../../../../components/loader/tableLoader.jsx";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import renameIcon from "../../../../assets/images/docs/renameIcon.png";
import signatureIcon from "../../../../assets/images/docs/signatureIcon.png";
import submitIcon from "../../../../assets/images/docs/submitIcon.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArchiveRoundedIcon from "@mui/icons-material/ArchiveRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import DescriptionIcon from "@mui/icons-material/Description";
import DocsSubHeader from "./subHeader/index.jsx";
import SignatureListing from "./signatureListing.jsx";
import RenameItem from "../components/rename.jsx";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import InfoDetail from "../components/infoDetail.jsx";

// Moved action options outside component to prevent recreation
const ACTION_OPTIONS = [
  { value: "summit", label: "Submit", icon: submitIcon, type: "img" },
  { value: "rename", label: "Rename", icon: renameIcon, type: "img" },
  { value: "copy", label: "Copy", icon: ContentCopyIcon, type: "icon" },
  // { value: "move", label: "Move", icon: OpenWithRoundedIcon, type: "icon" },
  {
    value: "archive",
    label: "Archive",
    icon: ArchiveRoundedIcon,
    type: "icon",
  },
  {
    value: "download",
    label: "Download",
    icon: DownloadRoundedIcon,
    type: "icon",
  },
  { value: "sign", label: "Sign", icon: signatureIcon, type: "img" },
  { value: "send", label: "Send", icon: SendRoundedIcon, type: "icon" },
  {
    value: "info",
    label: "Info",
    icon: ErrorOutlineOutlinedIcon,
    type: "icon",
  },
];

// Extracted MenuList component for better organization
const ActionMenu = React.memo(
  ({ open, anchorEl, onClose, onActionClick, setOpenDetail }) => (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <List sx={{ width: "100%", minWidth: 240 }} disablePadding>
        {ACTION_OPTIONS.map((item, index) => {
          const Icon = item.icon;
          return (
            <ListItem
              onClick={() => {
                onActionClick(item);
                onClose();
                if (item.value === "info") {
                  setOpenDetail(true);
                }
              }}
              key={index}
              disablePadding
            >
              <ListItemButton dense>
                <ListItemIcon sx={{ minWidth: "40px !important" }}>
                  {item.type === "img" ? (
                    <img
                      style={{ objectFit: "contain" }}
                      src={item.icon}
                      alt={item.label}
                      width={
                        item.label === "Rename" || item.label === "Submit"
                          ? 25
                          : 30
                      }
                      height={
                        item.label === "Rename" || item.label === "Submit"
                          ? 25
                          : 30
                      }
                    />
                  ) : (
                    <Icon
                      sx={{
                        fontSize: "20px",
                        transform:
                          item.label === "info" ? "rotate(180deg)" : "",
                      }}
                    />
                  )}
                </ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Menu>
  )
);

const DocsListing = (props) => {
  const { classes } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [folderDetails, setFolderDetails] = useState(null);
  const [docDetails, setDocDetails] = useState(null);
  const [docaArray, setDocsArr] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedCheckboxIds, setSelectedCheckboxIds] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [openerror, setOpenerror] = useState(false);
  const [alertType, setAlertType] = useState();
  const [alertMessage, setAlertMessage] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [openMenu, setOpenMenu] = useState(null);
  const [value, setValue] = useState("1");
  const [openRename, setOpenRename] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [sortModel, setSortModel] = useState([]);

  const docs = useSelector((state) => state.Docs.docs);
  const agents = useSelector((state) =>
    state.users.storedListOfUsers.list.filter(
      (user) => user.is_agent === true && user.status === "active"
    )
  );

  // Memoized handlers
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleChange = useCallback((_, newValue) => {
    setValue(newValue);
    setSortModel([]);
  }, []);

  const handleSearchInputChange = useCallback(
    (e) => setSearchValue(e.target.value),
    []
  );

  const handlePageSizeChange = useCallback((params) => setPageSize(params), []);
  const handleMenuClose = useCallback(() => setOpenMenu(null), []);
  const handleMenuOpen = useCallback((e) => {
    e.stopPropagation();
    setOpenMenu(e.currentTarget);
  }, []);
  const redirectDetails = useCallback(
    (data) => {
      if (data.type === "folder") {
        navigate(`/docs/folders/${data.id}`, {
          state: {
            folderDetails: data,
            name: location?.state?.name || data?.name,
          },
        });
      } else {
        navigate(`/docs/folders/${data.folder_id}/form/${data.id}/edit`);
      }
    },
    [navigate]
  );

  const archiveFunction = useCallback(async () => {
    if (selectedCheckboxIds?.length > 0) {
      try {
        await Promise.all(
          selectedCheckboxIds.map((folderId) =>
            dispatch(deleteFolder(folderId))
          )
        );
        setDocsArr([]);
        setOpenerror(true);
        setAlertType("success");
        setAlertMessage("You have successfully Archive the folder");
      } catch (error) {
        setOpenerror(true);
        setAlertType("error");
        setAlertMessage("Error archiving folders");
      }
    } else {
      setOpenerror(true);
      setAlertType("error");
      setAlertMessage("Please select folders or folder");
    }
  }, [selectedCheckboxIds, dispatch]);

  // Memoized filtered rows
  const filteredRows = useMemo(() => {
    if (!docs?.data?.length) return [];
    if (!searchValue) return docs.data;
    return docs.data.filter((row) =>
      row?.forms_data?.name?.toLowerCase().includes(searchValue?.toLowerCase())
    );
  }, [docs?.data, searchValue]);

  const handleSelectAll = useCallback(
    (e) => {
      if (!e.target.checked) {
        setSelectedCheckboxIds([]);
      } else {
        if (filteredRows?.length === 0) return;
        setSelectedCheckboxIds(filteredRows.map((item) => item.id));
      }
    },
    [filteredRows?.length]
  );

  // Memoized columns configuration
  const columns = useMemo(
    () => [
      {
        field: "name",
        headerName: "Document Name",
        renderCell: (params) => (
          <Grid
            container
            onClick={() => redirectDetails(params.row)}
            className={classes.mAlign}
            alignItems="center"
            xs="auto"
          >
            {params.row?.type === "folder" ? (
              <FolderRoundedIcon
                sx={{ color: "rgba(0, 0, 0, 0.54)", mr: "15px" }}
              />
            ) : (
              <DescriptionIcon
                sx={{ color: "rgba(0, 0, 0, 0.54)", mr: "15px" }}
              />
            )}
            <span>{params.row?.forms_data?.name || params.row?.name}</span>
          </Grid>
        ),
        valueGetter: (params) => {
          return params.row?.forms_data?.name || params.row?.name;
        },
        flex: 1,
        editable: false,
        sortable: true,
      },
      {
        field: "mls_listing_id",
        headerName: "MLS #",
        renderCell: ({ row }) => row?.mls_listing_id,
        width: 150,
        editable: false,
        sortable: true,
      },
      {
        field: "first_name",
        headerName: "Owner",
        renderCell: (params) => {
          const agent = agents?.find(
            (item) =>
              item.id === params.row.agent_id ||
              item.id === params.row?.folder_data?.agent_id
          );
          return agent ? (
            <Stack
              onClick={() => redirectDetails(params.row)}
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Avatar
                src={agent?.profile_images?.profile_img}
                sx={{
                  width: 26,
                  height: 26,
                  fontWeight: "400",
                }}
                variant="circular"
              >
                {agent?.first_name?.slice(0, 1)}
              </Avatar>
              <ListItemText
                secondary={`${agent?.first_name} ${agent?.last_name}`}
              />
            </Stack>
          ) : null;
        },
        valueGetter: (params) => {
          const agent = agents?.find(
            (item) =>
              item.id === params.row.agent_id ||
              item.id === params.row?.folder_data?.agent_id
          );
          return agent?.first_name || agent?.last_name;
        },

        width: 250,
        editable: false,
        sortable: true,
      },
      {
        field: "last_updated_at",
        headerName: "Date Modified",
        renderCell: (params) => (
          <Grid container onClick={() => redirectDetails(params.row)}>
            {moment(params.row.last_updated_at).format("HH:mm MM-DD-YYYY")}
          </Grid>
        ),
        valueGetter: (params) => {
          return moment(params.row.last_updated_at).format("HH:mm MM-DD-YYYY");
        },
        width: 150,
        editable: false,
        sortable: true,
      },
      {
        headerName: "",
        type: "actions",
        renderCell: ({ row }) => (
          <Box
            onClick={(e) => {
              e.stopPropagation();
              setOpenMenu(e.currentTarget);
              if (row.type === "folder") {
                setFolderDetails(row);
                setDocDetails(null);
              } else {
                setDocDetails(row);
                setFolderDetails(null);
              }
            }}
            sx={{ display: "flex", justifyItems: "center" }}
          >
            <IconButton>
              <MoreVertRoundedIcon />
            </IconButton>
          </Box>
        ),
        width: 50,
      },
    ],
    [classes.mAlign, redirectDetails, agents, handleMenuOpen]
  );

  const handleSortChange = useCallback((newSortModel) => {
    setSortModel(newSortModel);
  }, []);

  useEffect(() => {
    dispatch(getDocsList(id));
  }, [dispatch, id]);

  return (
    <div className={classes.pageRoot}>
      <HeaderDocs
        addFolderModal={handleOpen}
        selectedCheckboxIds={selectedCheckboxIds}
        archiveFunction={archiveFunction}
        handleSearchInputChange={handleSearchInputChange}
        actionOptions={ACTION_OPTIONS}
      />
      <Box className={classes.subHeaderArea}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{
                borderBottom: "none !important",
                padding: "0px 20px !important",
              }}
              TabIndicatorProps={{
                sx: {
                  backgroundColor: "rgba(79, 46, 46, 0.87) !important",
                  height: 3,
                },
              }}
            >
              <Tab
                sx={{
                  textTransform: "capitalize",
                  color: "gray",
                  "&.Mui-selected": {
                    color: "rgba(0, 0, 0, 0.87)",
                  },
                }}
                label="Documents"
                value="1"
              />
              <Tab
                sx={{
                  textTransform: "capitalize",
                  color: "gray",
                  "&.Mui-selected": {
                    color: "rgba(0, 0, 0, 0.87)",
                  },
                }}
                label="E-Signs"
                value="2"
              />
              <Tab
                sx={{
                  textTransform: "capitalize",
                  color: "gray",
                  "&.Mui-selected": {
                    color: "rgba(0, 0, 0, 0.87)",
                  },
                }}
                label="Archives"
                value="3"
              />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ padding: "0px" }}>
            <>
              <DocsSubHeader
                actionOptions={ACTION_OPTIONS}
                selectedCheckboxIds={selectedCheckboxIds}
                handleSelectAll={handleSelectAll}
                id={id}
                onSortChange={handleSortChange}
                docsData={docs?.data}
                setFolderDetails={setFolderDetails}
                setOpenDetail={setOpenDetail}
              />
              <Container maxWidth="xl">
                <Box
                  sx={{
                    height: "80vh",
                    width: "100%",
                    "& .Mui-checked": { color: "#1D1B20 !important" },
                    backgroundColor: "white",
                  }}
                >
                  <DataGridPro
                    loading={docs.isLoading}
                    components={{
                      LoadingOverlay: TableSkeleton,
                    }}
                    rows={filteredRows}
                    columns={columns}
                    pageSize={pageSize}
                    checkboxSelection={true}
                    rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
                    onRowSelectionModelChange={setSelectedCheckboxIds}
                    rowSelectionModel={selectedCheckboxIds}
                    handlePageSizeChange={handlePageSizeChange}
                    sortModel={sortModel}
                    onSortModelChange={(model) => setSortModel(model)}
                  />
                  <AddFolder open={open} setOpen={setOpen} />

                  <ResponseAlert
                    setOpen={setOpenerror}
                    open={openerror}
                    alertType={alertType}
                    alertMessage={alertMessage}
                  />

                  <ActionMenu
                    open={Boolean(openMenu)}
                    anchorEl={openMenu}
                    onClose={handleMenuClose}
                    setOpenDetail={setOpenDetail}
                    onActionClick={(data) => {
                      if (
                        data.label === "Rename" &&
                        folderDetails?.type === "folder"
                      ) {
                        setOpenRename(true);
                      }
                    }}
                  />
                </Box>
              </Container>
            </>
          </TabPanel>
          <TabPanel value="2" sx={{ padding: "0px" }}>
            <DocsSubHeader
              actionOptions={ACTION_OPTIONS}
              selectedCheckboxIds={selectedCheckboxIds}
              handleSelectAll={handleSelectAll}
              isEsign={true}
              onSortChange={handleSortChange}
            />
            <SignatureListing
              {...props}
              setSelectedCheckboxIds={setSelectedCheckboxIds}
              sortModel={sortModel}
              onSortModelChange={(model) => setSortModel(model)}
              id={id}
            />
          </TabPanel>
          <TabPanel value="3">Archive section</TabPanel>
        </TabContext>
      </Box>
      <RenameItem
        open={openRename}
        setOpen={setOpenRename}
        folderDetails={folderDetails}
      />
      <InfoDetail
        open={openDetail}
        setOpen={setOpenDetail}
        folderDetails={folderDetails || docDetails}
      />
    </div>
  );
};

export default React.memo(
  withStyles(styleSheet, { name: "DocsStyle" })(DocsListing)
);
